import styled, {css} from "styled-components"
import { motion } from "framer-motion";
const ProductoContainer = styled(motion.div) `
    background-color: #FFFFFF;
    box-shadow: 0px 0 3px #0003;
    padding: 8px 5px;
    min-width: 165px;
    max-width: 165px;
    min-height: 295px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;
    gap: 10px;
    
    img {
        width: 140px;
        border-radius: 8px;
    }
    h4 {
        text-align: center;
    }
    button, a {
        background-color: #00054C;
        color: #fff;
        padding: 8px 9px;
        font-size: 14px;
        border: none;
        border-radius: 10px;
    }
    p {
        text-align: center;
    }
    ${props => props.productoToldo && css`
        min-width: 330px;
        max-width: 600px;
        min-height: auto;
        
        
        img {
            height: 200px;
            width: 80%;
            border-radius: 8px;
        }

    }
    `}
`
export default ProductoContainer;